import { useCallback, useState } from "react";

const STORAGE_KEY = "vyv_intro_seen";
const RESHOW_AFTER_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function useSplashSeen() {
  const [shouldShow, setShouldShow] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) return true;
      const elapsed = Date.now() - parseInt(stored, 10);
      return Number.isNaN(elapsed) || elapsed > RESHOW_AFTER_MS;
    } catch {
      return true;
    }
  });

  const markSeen = useCallback(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch {
      // localStorage may be unavailable (private mode / Capacitor edge cases) —
      // splash will simply re-show next session, which is acceptable.
    }
    setShouldShow(false);
  }, []);

  const forceShow = useCallback(() => {
    setShouldShow(true);
  }, []);

  return { shouldShow, markSeen, forceShow };
}
